export const GrainOverlay = () => (
  <div className="grain-overlay" aria-hidden="true" />
);

export const Marquee = ({ items = [], className = "" }) => {
  const loop = [...items, ...items];
  return (
    <div className={`marquee-wrap overflow-hidden ${className}`} data-testid="editorial-marquee">
      <div className="marquee-track">
        {loop.map((it, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="px-8 font-serif italic text-4xl sm:text-6xl lg:text-7xl leading-none">
              {it}
            </span>
            <span className="text-henna text-2xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
